import { useState, useEffect } from "react";
import { Checkbox } from "react-aria-components";
import FilterSelectWrapper from "../Filters/FilterSelectWrapper";
import FormSectionSelectWrapper from "../entityComponents/Form/components/FormSectionSelectWrapper";
import { ISchemaFilter } from "../entityComponents/Schema";
import { IOption } from "../../AdobeAriaLib/AdobeComboBox";
import { EntityNames } from "../../../enums/EntityNames";
import CheckIcon from "../../../assets/icons/icon-check-white.svg";

interface ICaseMaterialTypesDropdown {
    filter: ISchemaFilter;
    filterValues: any;
    label: string | null | undefined;
    labelVisible: boolean;
    onChange: Function;
    className?: string;
    preBuiltOptions?: IOption[];
}

export default function CaseMaterialTypesDropdown({
    filter,
    filterValues,
    label,
    labelVisible,
    onChange,
    className,
    preBuiltOptions
}: ICaseMaterialTypesDropdown) {
    const [showDetailed, setShowDetailed] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (showDetailed) {
            setIsLoading(true);
            // Small delay to show loader during switch
            const timer = setTimeout(() => {
                setIsLoading(false);
            }, 250);
            return () => clearTimeout(timer);
        } else {
            setIsLoading(false);
        }
    }, [showDetailed]);

    const currentValue = filterValues?.find((x: any) => x.propertyName === filter.PropertyName)?.value;

    return (
        <div className={`cell ${className ?? filter.className}`}>
            <div className="display--flex flex__direction--row alignItems--center gap--xs">
                <div className="case-material-types-dropdown__container">
                    {isLoading ? (
                        <div className="case-material-types-dropdown__loader-wrapper">
                            <div className="loaders loaders__list"></div>
                        </div>
                    ) : showDetailed ? (
                        <FormSectionSelectWrapper
                            value={currentValue || ""}
                            placeHolder="Please select"
                            label={filter.displayName}
                            entityName={EntityNames.caseMaterialTypes}
                            required={filter.required}
                            onChange={(value: string) => {
                                // Match the signature expected by FilterSelectWrapper
                                onChange(value);
                            }}
                            isCreate={true}
                            labelClassName="margin__bottom--xxs"
                        />
                    ) : (
                        <FilterSelectWrapper
                            filter={filter}
                            filterValues={filterValues}
                            labelVisible={labelVisible}
                            onChange={onChange}
                            className={undefined}
                            preBuiltOptions={preBuiltOptions}
                        />
                    )}
                </div>
                <div className="case-material-types-dropdown__checkbox-wrapper">
                    <Checkbox
                        isSelected={showDetailed}
                        onChange={setShowDetailed}
                        className="display--flex alignItems--center gap--xxs"
                    >
                        <div className={`input-checkbox ${showDetailed ? "input-checkbox--selected" : "input-checkbox--unselected"}`}>
                            {showDetailed && <img alt="" src={CheckIcon} />}
                        </div>
                        <span className="small">Show detailed</span>
                    </Checkbox>
                </div>
            </div>
        </div>
    );
}
